import classNames from 'classnames/bind';
import styles from './Select.module.css';
import { useRef, useState } from 'react';
import { useSelect } from '../../hooks/useSelect';
import SimpleBar from 'simplebar-react';
import useSimpleBar from '../../hooks/useSimpleBar';

interface Select {
  list: string[];
  value: string;
  onClick: (value: string, i: number) => void;
  name?: string;
  onlyText?: boolean;
  pos?: 'left' | 'right';
}

export default function Select({
  list,
  value,
  onClick,
  name,
  onlyText,
  pos,
}: Select) {
  const cx = classNames.bind(styles);
  const [isOpen, setIsOpen] = useState(false);

  const selectRef = useRef(null);
  const [simplebarRef] = useSimpleBar();

  const clickOption = (value: string, i: number) => {
    onClick(value, i);
    setIsOpen(false);
  };

  useSelect(selectRef, () => setIsOpen(false));

  return (
    <div className={cx('select_wrap', name)} ref={selectRef}>
      <button
        className={cx('btn', 'select_toggle', { no_select: onlyText })}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={cx('setting_option')}>{value}</span>
        <input type="text" className={cx('blind')} />
      </button>

      {isOpen && (
        <div className={cx('select_menu', pos)}>
          <ul className={cx('select_list')}>
            <SimpleBar forceVisible={true} ref={simplebarRef}>
              {list.map((value, i) => (
                <li
                  key={value}
                  className={cx('items')}
                  onClick={() => clickOption(value, i)}
                >
                  <span>{value}</span>
                </li>
              ))}
            </SimpleBar>
          </ul>
        </div>
      )}
    </div>
  );
}
